import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=ae513e76"
import script from "./ModalFooter.vue?vue&type=script&lang=ts"
export * from "./ModalFooter.vue?vue&type=script&lang=ts"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=ae513e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports